<template>
  <ResponsibilityTemplate :loading="loading" :items="items" />
</template>

<script>
import ResponsibilityTemplate from "../components/templates/ResponsibilityTemplate.vue";

const _config = {
  mod: "environmentalResponsibility",
};

export default {
  data: () => ({
    loading: true,
  }),
  created() {
    this.$rest(_config.mod)
      .get()
      .then(() => (this.loading = false));
  },
  computed: {
    items() {
      return this.$rest(_config.mod).list;
    },
  },
  components: {
    ResponsibilityTemplate,
  },
};
</script>
